import { sendEmail } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { InvoiceCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = CustomApiHandler<InvoiceCollectionModel & HasOnSuccess & HasOnError, any
>;

export const DispatchBeginSendInvoicePaymentEmail: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginSendInvoicePaymentEmail",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {...props.parameter};
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await sendEmail(props.apiParameter);
};

export const CompleteSendInvoicePaymentEmail: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteSendInvoicePaymentEmail",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchBeginSendInvoicePaymentEmail, PopulateApiParameter, SendDataToApi, CompleteSendInvoicePaymentEmail];

const adiSendInvoicePaymentEmail = createHandlerChainRunner(
    chain,
    "ADISendInvoicePaymentEmail",
);
export default adiSendInvoicePaymentEmail;
